import React from 'react';
import { Link } from 'react-router-dom';

import { useTheme } from '../contexts/ThemeContext';

interface HeaderProps {
    roomName?: string;
    roomCode?: string;
}

const Header: React.FC<HeaderProps> = ({ roomName, roomCode }) => {
    const { isDarkMode, toggleDarkMode } = useTheme();

    return (
        <header className="bg-gradient-to-r from-primary-dark to-primary dark:from-gray-800 dark:to-gray-900 text-white shadow-md">
            <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center">
                <h1 className="text-2xl font-bold">
                    <Link
                        to="/"
                        className="text-white no-underline hover:text-blue-100 dark:hover:text-blue-200 transition-colors duration-200 flex items-center"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 mr-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                            />
                        </svg>
                        Planning Poker
                    </Link>
                </h1>
                <div className="mt-2 sm:mt-0 flex items-center gap-4">
                    {roomName && roomCode && (
                        <div className="text-center sm:text-right">
                            <h2 className="text-xl font-semibold">
                                {roomName}
                            </h2>
                            <div className="flex items-center justify-center sm:justify-end mt-1">
                                <span className="text-blue-100 dark:text-blue-200">
                                    Room Code:
                                </span>
                                <span className="ml-2 bg-white dark:bg-gray-700 text-primary dark:text-blue-300 font-mono px-2 py-1 rounded text-sm font-bold">
                                    {roomCode}
                                </span>
                                <button
                                    onClick={() =>
                                        navigator.clipboard.writeText(
                                            `https://poker.bwatson.uk/?join=${roomCode}`,
                                        )
                                    }
                                    className="ml-2 text-white hover:text-blue-100 dark:hover:text-blue-200 focus:outline-none"
                                    title="Copy room code URL to clipboard"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    )}
                    <button
                        onClick={toggleDarkMode}
                        className="p-2 rounded-lg hover:bg-white/10 dark:hover:bg-black/20 transition-colors"
                        title={
                            isDarkMode
                                ? 'Switch to light mode'
                                : 'Switch to dark mode'
                        }
                    >
                        {isDarkMode ? (
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                                />
                            </svg>
                        ) : (
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                                />
                            </svg>
                        )}
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
